export function globalSet(name, val) {
    window.sps = window.sps || {};
    let obj = window.sps;
    name.split('.').forEach((key, i, arr) => {
        obj[key] = obj[key] || {};
        obj[key] = (i + 1 === arr.length) ? val : obj[key];
        obj = obj[key];
    });
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/utils/global/global.ts